import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useStateContext } from '../contexts/ContextProvider';
import { UALProvider } from 'ual-reactjs-renderer';
import {Helmet} from "react-helmet";
import { CallToActionCont, StatsCont, SingleStat, SingleStatHeader, SingleStatDetail, FeaturesCont, SingleFeature, TrustedBySmall, BenefitsCont, SingleBenefitPic, SingleBenefitText, SingleBenefitTitle, SingleBenefitDescription, SocialProofCont, SocialProofTitle, SocialProofLogoCont, LastCallToActionCont, LastCallToActionTitle, HomepageFAQCont, HomepageFAQTitle, HomepageFAQDescription, HomepageQuestion, HomepageQuestionPlusSign, HomepageFAQAnswer, FAQHref } from '../components/LeftDiv';
import { anchor, wax, myChain, atomicApiList, hyperionApiList, mainnetApiList, mainnetAtomicApiList, currentWebsiteURL, currentAtomicApiList, currentApiList, localServerURL, getStatsEndpoint, wombat, currentIpfsEndpoint, APP_NAME } from '../data/config';
import { HomePageCont, HeroLeftSide, HeroRightSide, HeroLargeText, HeroMediumText, CallToActionHrefHomepage, CallToActionContent, HeroAd, HeroAdImage, HeroAdMessage, WojakCallToAction, SocialProofSingleLogo } from '../data/css/HomePageStyles';
import { WHITEPAPER_URL, ipfsPrefix } from '../data/constants';
import "./homepage-styles.css"
import { useGetConfig } from '../components/CustomHooks/useGetConfig';
import LoadingPage from '../components/LoadingPage';
import { GlowButton, SocialsButton } from '../Styles';

export const Page = styled.div`
  padding: 2em;
  //background: linear-gradient(to right, #000046, #1cb5e0);
  color: white;
  font-family: Arial, sans-serif;
  text-align: center;
`;

const Heading = styled.h1`
  font-size: 2.5em;
`;

const Description = styled.p`
  font-size: 1.2em;
  //max-width: 600px;
`;

const Table = styled.table`
  width: 100%;
  margin-top: 2em;
  border-collapse: collapse;
  th, td {
    padding: 1em;
    text-align: left;
    border: 1px solid white;
  }
  th {
    background-color: #007BFF;
    color: white;
  }
  tr:nth-child(even) {
    background-color: #f2f2f2;
    color: black;
  }
`;

const HomePage = () => {

  return (
    <div id="seo">
      <Helmet>
      <title>Home - WaxDAO Names</title>
      <meta name="description" content="Your one-stop shop for premium WAX names" />
      <link rel="canonical" href={currentWebsiteURL} />
      </Helmet>
  
      <UALProvider chains={[myChain]} authenticators={[anchor, wax, wombat]} appName={APP_NAME}>
    <br/><br/><br/>
  <Page>
      <Heading>WaxDAO Names</Heading>
      <Description>Your one-stop shop for buying premium WAX names!</Description>
   
   <a href={`${currentWebsiteURL}/buy`}>
    <GlowButton>
      Buy Custom Names
    </GlowButton>
    </a>

    <a href={`${currentWebsiteURL}/sell`}>
    <SocialsButton>
      Sell Names
    </SocialsButton>
    </a>

    <a href={`${currentWebsiteURL}/faq`}>
    <SocialsButton>
      How It Works
    </SocialsButton>
    </a>

    </Page>
  
      </UALProvider>
      <br/><br/><br/>
      </div>
    )
}

export default HomePage